"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isInCenter = exports.isOnLeft = exports.isOnTop = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _constants = require("./constants");

var _sharedPropTypes = require("./sharedPropTypes");

var isOnTop = function isOnTop(arrowPosition) {
  return arrowPosition === _constants.ARROW_POSITION.TOP_LEFT || arrowPosition === _constants.ARROW_POSITION.TOP_RIGHT || arrowPosition === _constants.ARROW_POSITION.TOP_CENTER;
};

exports.isOnTop = isOnTop;

var isOnLeft = function isOnLeft(arrowPosition) {
  return arrowPosition === _constants.ARROW_POSITION.TOP_LEFT || arrowPosition === _constants.ARROW_POSITION.BOTTOM_LEFT;
};

exports.isOnLeft = isOnLeft;

var isInCenter = function isInCenter(arrowPosition) {
  return arrowPosition === _constants.ARROW_POSITION.TOP_CENTER || arrowPosition === _constants.ARROW_POSITION.BOTTOM_CENTER;
};

exports.isInCenter = isInCenter;
var ArrowContainer = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e125okj80"
})("position:absolute;width:32px;height:16px;overflow:hidden;", function (_ref) {
  var _ref2;

  var arrowPosition = _ref.arrowPosition;
  var verticalProp = isOnTop(arrowPosition) ? 'top' : 'bottom';
  var horizontalProp = isOnLeft(arrowPosition) || isInCenter(arrowPosition) ? 'left' : 'right';
  var horizontalValue = isInCenter(arrowPosition) ? 'calc(50% - 16px)' : '-6px';
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, verticalProp, '-16px'), (0, _defineProperty2.default)(_ref2, horizontalProp, horizontalValue), _ref2;
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
ArrowContainer.displayName = 'ArrowContainer';
ArrowContainer.propTypes = {
  arrowPosition: _sharedPropTypes.arrowPositionPropType.isRequired
};
var _default = ArrowContainer;
exports.default = _default;